import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AbstractService } from './abstract.service';

export interface UsoTotais {
  empresas: number;
  usuarios: number;
  diasComUso: number;
  logins: number;
  loginsPdv: number;
  entradas: number;
  tempo: number;
  rotinas: number;
  iaChamadas: number;
  iaTokensEntrada: number;
  iaTokensSaida: number;
}

export interface UsoDia {
  data: string;
  usuarios: number;
  logins: number;
  entradas: number;
  tempo: number;
  iaChamadas: number;
}

export interface UsoCategoria {
  categoria: string;
  entradas: number;
  tempo: number;
}

export interface UsoRotina {
  rotina: string;
  descricao: string;
  categoria: string;
  entradas: number;
  tempo: number;
  usuarios: number;
  empresas: number;
}

export interface UsoOrigem {
  origem: string;
  empresas: number;
}

export interface UsoClienteResumo {
  cnpj: string;
  nome?: string;
  origem?: string;
  empresas?: number;
  usuarios: number;
  diasComUso: number;
  logins: number;
  entradas: number;
  tempo: number;
  iaChamadas: number;
  ultimoAcesso?: number;
}

export interface UsoEmpresa {
  idEmpresa: number;
  nome?: string;
  cnpj?: string;
  cadastrada: boolean;
}

export interface UsoUsuarioResumo {
  idUsuario: number;
  nome?: string;
  diasComUso: number;
  logins: number;
  loginsPdv: number;
  entradas: number;
  tempo: number;
  rotinas: number;
  iaChamadas: number;
  iaTokens: number;
  ultimoAcesso?: number;
}

export interface UsoSistemaPainel {
  inicio: string;
  fim: string;
  cnpj?: string;
  nomeCliente?: string;
  idUsuario?: number;
  nomeUsuario?: string;
  idEmpresa?: number;
  nomeEmpresa?: string;
  totais: UsoTotais;
  dias: UsoDia[];
  categorias: UsoCategoria[];
  rotinas: UsoRotina[];
  origens: UsoOrigem[];
  clientes: UsoClienteResumo[];
  usuarios: UsoUsuarioResumo[];
  empresas: UsoEmpresa[];
}

export function formataDuracao(segundos: number): string {
  const s = Math.max(Math.round(Number(segundos) || 0), 0);
  if (s < 60) {
    return s + 's';
  }
  const horas = Math.floor(s / 3600);
  const minutos = Math.floor((s % 3600) / 60);
  if (horas === 0) {
    return minutos + 'min';
  }
  return horas.toLocaleString('pt-BR') + 'h' + (minutos ? ' ' + minutos + 'min' : '');
}

@Injectable({
  providedIn: 'root',
})
export class UsoSistemaService {
  constructor(private http: HttpClient) {}

  painel(inicio: string, fim: string, cnpj?: string, usuario?: number, empresa?: number): Observable<UsoSistemaPainel> {
    let params = new HttpParams().set('inicio', inicio).set('fim', fim);
    if (cnpj) {
      params = params.set('cnpj', cnpj);
    }
    if (usuario !== undefined && usuario !== null) {
      params = params.set('usuario', String(usuario));
    }
    if (empresa !== undefined && empresa !== null) {
      params = params.set('empresa', String(empresa));
    }
    return this.http.get<UsoSistemaPainel>(environment.api + '/admin/uso-sistema/painel', {
      headers: new HttpHeaders({
        Accept: 'application/json; charset=utf-8',
        'X-Auth-Token': AbstractService.token(),
      }),
      params,
    });
  }
}
